import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Delete = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, discardArticleInstanceSelection } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            discardArticleInstanceSelection: state.discardArticleInstanceSelection
        }))
    );

    const selectedInstanceIds = useMemo(() => Object.keys(articleInstanceSelections), [articleInstanceSelections]);

    return (
        <Menu.Item
            disabled={selectedInstanceIds.length === 0}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="delete" />
            }
            rightSection={<ActionShortcutHint actionId={InputActionId.ArticleDelete} />}
            onClick={() => discardArticleInstanceSelection(true)}
        >
            {t('delete')}
        </Menu.Item>
    );
};
